const setProducts = (state, value) => state.products = value;
const setRanges = (state, value) => state.ranges = value;
const setPodium = (state, value) => state.podium = value;
const setFeatured = (state, value) => state.featured = value;

const setOnlineGreenProduct = (state, value) => state.onlineGreenProduct = value;
const setOnlineGrayProduct = (state, value) => state.onlineGrayProduct = value;
const setForcedElecProduct = (state, value) => state.forcedElecProduct = value;
const setForcedGasProduct = (state, value) => state.forcedGasProduct = value;
const selectProducts = (state, payload) => {
  let index = state.ranges.findIndex(x => x.range === payload.range.range);
  if(payload.electricity)
    state.ranges[index].electricity = payload.electricity;

  if(payload.gas)
    state.ranges[index].gas = payload.gas;
}

export default {
  setProducts,
  setRanges,
  setOnlineGreenProduct,
  setOnlineGrayProduct,
  setPodium,
  setFeatured,
  selectProducts,
  setForcedElecProduct,
  setForcedGasProduct
}



// WEBPACK FOOTER //
// ./src/store/modules/offer/mutations.js